import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { IOrderStatisticsCount } from '@dss-libs/portal/type/portal-types';
import { OrderStatus } from '@dss-libs/shared/type/common-types';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';

@Component({
  selector: 'dss-libs-ui-widget',
  imports: [TranslocoDirective, MatIconModule, TranslocoDecimalPipe],
  templateUrl: './widget.component.html',
  styleUrl: './widget.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetComponent {
  allOrder = input<IOrderStatisticsCount | null>();
  activeOrders = input<IOrderStatisticsCount | null>();
  completedOrders = input<IOrderStatisticsCount | null>();
  closedOrders = input<IOrderStatisticsCount | null>();
  selectedStatus = input('');
  readonly filterByWidgetName = output<string>();

  readonly statItems = computed(() => [
    {
      status: '',
      iconActive: 'folder-bold',
      iconInactive: 'folder',
      count: this.allOrder()?.ordersCount || 0,
      labelKey: 'ORDER-STATISTICS.ALL-ORDER',
    },
    {
      status: OrderStatus.InProgress,
      iconActive: 'document-add-bold',
      iconInactive: 'document-add',
      count: this.activeOrders()?.ordersCount || 0,
      labelKey: 'ORDER-STATISTICS.ACTIVE-ORDERS',
    },
    {
      status: OrderStatus.Completed,
      iconActive: 'file-check-bold',
      iconInactive: 'file-check',
      count: this.completedOrders()?.ordersCount || 0,
      labelKey: 'ORDER-STATISTICS.COMPLETED-ORDERS',
    },
    {
      status: OrderStatus.Closed,
      iconActive: 'file-remove-bold',
      iconInactive: 'file-remove',
      count: this.closedOrders()?.ordersCount || 0,
      labelKey: 'ORDER-STATISTICS.CLOSED-ORDERS',
    },
  ]);

  onClick(status: string) {
    this.filterByWidgetName.emit(status);
  }
}
